import {Component, HostBinding, ViewChildren, inject} from '@angular/core';
import {Subscription} from 'rxjs';
import * as Sentry from '@sentry/angular';
@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage {
  private subscriptions = new Subscription();
  @HostBinding('class.hide')
  hideLoader = false;

  constructor() {}

  ngOnInit() {
    Sentry.captureMessage('New visit to log in page');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onFirebaseUiSuccess(event: any) {
    // possible handler for succes log in
  }

  onFirebaseUiError(event: any) {
    // possible handler for unsuccessfgullasdasd log in
  }

  goHome() {
    return window.open('https://www.monitoraustral.cl', '_blank');
  }
}
